import { Browsers } from '../constants/AppConstants';

export function deviceDetection () {
    if (navigator.userAgent.match(/Android/i)) {
        return 'Android';
    } else if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
        return 'iOS';
    } else {
        return 'Android';
    }
}

export function browserDetection () {
    if (navigator.userAgent.match(/CriOS/i)) {
        return Browsers.IOS_CHROME;
    } else {
        return Browsers.CHROME;
    }
}
